import type { PageContent } from "../types";

export const terms_and_conditions: PageContent = {
  slug: "terms-and-conditions",
  title: `Terms & Conditions | Phil Carr – SEO Consultant & Web Strategist`,
  description: `Review the terms and conditions for engaging Phil Carr for SEO and web design services across Barnsley and the UK.`,
  body: `# Terms & Conditions

These terms and conditions outline the agreement between you (the "Client") and Phil
Carr ("we", "us", or "our") when you engage our SEO, web design, or digital marketing services. I provide SEO strategy, web design, content, and related digital marketing services as agreed in
writing.

## Services

Deliverables, timelines, and pricing will be outlined in a proposal or contract.

## Client responsibilities

- Provide timely access to content, approvals, and required assets.
- Review and approve deliverables within agreed timeframes.
- Ensure any supplied materials do not infringe third-party rights.

## Fees and payment

Fees are outlined in your proposal or contract. Invoices are payable within the agreed terms. Late
payments may pause work until accounts are settled.

## Intellectual property

Upon full payment, you receive a licence to use the deliverables produced for your business. I
retain the right to display work in our portfolio unless otherwise agreed.

## SEO performance

Search engine rankings can fluctuate due to algorithm changes, competition, and market conditions. I
cannot guarantee specific rankings or revenue outcomes, but best practice strategies are applied
throughout the engagement.

## Limitation of liability

I am not liable for indirect, incidental, or consequential losses. Liability is limited to the
fees paid for the services giving rise to the claim.

## Termination

Either party may terminate services with written notice in line with the agreed contract. Any work
completed up to the termination date remains payable.

## Third-party services

Some services may rely on third-party platforms (e.g., hosting, analytics). I am not responsible for
third-party outages, changes, or data processing beyond our control.

## Governing law

These terms are governed by the laws of England and Wales. Any disputes will be resolved in those
courts.

## Contact

For questions about these terms, email [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or call 01226 697 325.

[Back to Top](/#top)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)`,
};
